'use client';
import React, { useRef, useState } from "react";
import Link from "next/link";
import StartTrialBtn from "../StartTrialBtnProducts";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import Image from "next/image";
import LearnLeadExcelIco from "@/Helper/images/learn_lead_excel.svg";
import CollaborateElevateIco from "@/Helper/images/collaborate_elevate.svg";
import ClientCenteredExcellenceIco from "@/Helper/images/client_centered_excellence.svg";
import EmpoweredOwnershipIco from "@/Helper/images/empowered_ownership.svg";
import InnovateWithInsightIco from "@/Helper/images/innovate_withInsight.svg";
import ApplyOnlineICo from "@/Helper/images/apply_onlineico.svg";
import ScreeningIco from "@/Helper/images/screeningIco.svg";
import InitialInterview from "@/Helper/images/initial_interview.svg";
import TechnicalRound from "@/Helper/images/technical_round.svg";
import FinalRound from "@/Helper/images/final_round.svg";

export default function CareersList() {
  // Define the ref for the apply form
  const applyFormRef = useRef(null);

  // Define the handleScrollToForm function
  const handleScrollToForm = () => {
    if (applyFormRef.current) {
      applyFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const AccordionItem = ({ title, content, isOpen, toggle }) => {
    return (
      <div className="accordion-item">
        <div className="accordion-title" onClick={toggle}>
          <h3>{title}</h3>
          <span>{isOpen ? "-" : "+"}</span>
        </div>
        {isOpen && <div className="accordion-content">{content}</div>}
      </div>
    );
  };
  const [openItem, setOpenItem] = useState(0);
  const toggleAccordion = (index) => {
    setOpenItem(openItem === index ? null : index);
  };
  const accordionData = [
    {
      title: "Competitive Compensation",
      content: (
        <>
          <p>
            Receive industry-leading salary packages and performance-based rewards for your efforts.
          </p>
        </>
      ),
    },
    {
      title: "Work-Life Balance",
      content: (
        <>

          <p>
            Enjoy flexible work options and supportive policies to help you balance personal and professional
            priorities.
          </p>
        </>
      ),
    },
    {
      title: "Health and Wellness",
      content: (
        <>
          <p>
            Comprehensive health insurance and wellness initiatives for you and your family’s well-being.
          </p>
        </>
      ),

    },
    {
      title: "Continuous Learning",
      content: (
        <>
          <p>
            Access upskilling opportunities, certifications, and workshops to stay ahead in your career.
          </p>
        </>
      ),
    },
    {
      title: "Collaborative Culture",
      content: (
        <>
          <p>
            Be part of a diverse, inclusive, and vibrant workplace where your ideas matter.
          </p>
        </>
      ),
    },
    {
      title: "Career Growth",
      content: (
        <>
          <p>
            Benefit from mentorship programs and leadership opportunities to advance your career trajectory.
          </p>
        </>
      ),
    },
    {
      title: "Recognition and Rewards",
      content: (
        <>
          <p>
            Get acknowledged for your contributions through our employee appreciation programs.
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <section className="banner_bg1 careerlist_bg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">Discover Your Future at iKnot Analytics</h1>
              <p className="banner_text1">
                Join us to innovate, collaborate, and build the future of analytics.
              </p>
              <div className="banner_btn_container">

                <button onClick={handleScrollToForm} className="vi_btn1 not-loading btn  btn-primary btn-common-style">APPLY Today!</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about_topsect about_topsectcareers">
        <div className="container">
          <div className="about_topsectinner">
            <div className="common_titbox">
              <h2 className="common_hd">Who We Are
              </h2>
              <p className="common_desc">At <strong>iKnot Analytics,</strong> we specialize in transforming complex data into actionable insights, empowering
                businesses to make smarter, faster, and better decisions. Our expertise in supply chain analytics,
                coupled with our commitment to innovation and collaboration, has established us as a trusted
                partner for leading organizations.</p>
             
            </div>
          </div>
        </div>
      </section>

      <section className="why_hireapp">
        <div className="container">
          <div className="why_hireappinner">
            <div className="why_hireleft">
              <div className="common_titbox">
                <h2 className="common_hd">Core Values</h2>
                <p className="common_desc">Driven by our core values, we believe in continuous learning, collaborative problem-solving, and
                delivering measurable results that matter. With a strong focus on supply chain analytics, we are
                committed to reshaping the future, one insight at a time.</p>
              </div>
            </div>
            <div className="why_hirergt">
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={LearnLeadExcelIco}
                    alt="Learn, Lead, Excel"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Learn, Lead, Excel</h3>
                  <p className="bx_rightdesc">We embrace continuous learning and empower leadership, fostering innovation and excellence in
                    every project.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={CollaborateElevateIco}
                    alt="Collaborate to Elevate"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Collaborate to Elevate</h3>
                  <p className="bx_rightdesc">By combining diverse expertise, we solve challenges together, driving shared growth and outstanding outcomes.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ClientCenteredExcellenceIco}
                    alt="Client-Centered Excellence"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Client-Centered Excellence</h3>
                  <p className="bx_rightdesc">We prioritize clients&#39; goals, delivering tailored solutions and building lasting relationships on trust and respect.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={EmpoweredOwnershipIco}
                    alt="Empowered Ownership"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Empowered Ownership</h3>
                  <p className="bx_rightdesc">We encourage initiative and confident decision-making, promoting responsibility in a collaborative
                    culture.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={InnovateWithInsightIco}
                    alt="Innovate with Insight"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Innovate with Insight</h3>
                  <p className="bx_rightdesc">We transform raw data into forward-thinking solutions, creating impactful insights and inspiring
                    opportunities.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="left_crlftsection">
        <div className="container">
          <div className="left_crlftinner">
            <div className="left_crlft">
              <div className="common_titbox"><h2 className="common_hd">What Makes Us Different?</h2></div>
              <div className="left_crlftmid">
                <ul>
                  <li><strong>A Culture of Innovation: </strong> At iKnot Analytics, we challenge the status quo by fostering a culture where
                    creativity and innovation thrive. Every day is an opportunity to solve complex challenges and create
                    groundbreaking solutions.</li>
                  <li><strong>Your Success, Our Mission: </strong> We don’t just invest in projects; we invest in people. From mentorship programs to leadership opportunities, your success is at the heart of everything we do.</li>
                  <li><strong>Global Impact, Local Focus: </strong> While our analytics solutions reach global industries, we maintain a deep commitment to understanding and addressing local challenges.</li>
                </ul>
              </div>
            </div>
            <div className="left_crlft">
              <div className="common_titbox"><h2 className="common_hd">Life at iKnot Analytics</h2></div>
              <div className="left_crlftmid">
                <h3 className="left-crlft-subheading">What’s it like to be part of our team?</h3>
                <ul>
                  <li><strong>Dynamic Work Environment: </strong> Every day brings new challenges and opportunities to grow.</li>
                  <li><strong>Celebrate Success Together: </strong> From team outings to project milestones, we celebrate
                    achievements as one family.</li>
                  <li><strong>Diversity Drives Us: </strong> Our diverse team fosters creativity and brings unique perspectives to
                    every solution.</li>
                  <li><strong>Impact Beyond Work: </strong> Join us in our community initiatives and make a difference beyond
                    the workplace.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="accordion-section">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Benefits of Working at iKnot Analytics</h2>
          </div>
          <div className="accordion accordioninner">
            {accordionData.map((item, index) => (
              <AccordionItem
                key={index}
                title={item.title}
                content={item.content}
                isOpen={openItem === index}
                toggle={() => toggleAccordion(index)}
              />
            ))}
          </div>
        </div>
      </section>
      <section class="infographic-section">
        <div class="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Our Recruitment Process</h2>
            <p className="common_desc">We believe in transparency and simplicity. Here’s what to expect:</p>
          </div>

          <div class="infographic-steps">
            <div class="step-card step-card1">
              <div className="iconouter">
                <div class="icon">
                  <Image
                    src={ApplyOnlineICo}
                    alt="Apply Online"
                  />
                </div>
              </div>
              <h3 class="step-title">Apply Online</h3>
              <p class="step-desc">
                Submit your resume and cover letter.
              </p>
              <div class="step-number">01</div>
            </div>
            <div class="step-card step-card2">
            <div className="iconouter">
              <div class="icon">
                <Image
                  src={ScreeningIco}
                  alt="Screening"
                />
              </div>
              </div>
              <h3 class="step-title">Screening</h3>
              <p class="step-desc">
                Our team reviews your application to match your skills with the role.
              </p>
              <div class="step-number">02</div>
            </div>
            <div class="step-card step-card3">
            <div className="iconouter">
              <div class="icon">
                <Image
                  src={InitialInterview}
                  alt="Initial Interview"
                />
                </div>
              </div>
              <h3 class="step-title">Initial Interview</h3>
              <p class="step-desc">
                A conversation to learn more about you and your aspirations.
              </p>
              <div class="step-number">03</div>
            </div>
            <div class="step-card step-card4">
            <div className="iconouter">
              <div class="icon">
                <Image
                  src={TechnicalRound}
                  alt="Technical Round"
                />
              </div>
              </div>
              <h3 class="step-title">Technical Round</h3>
              <p class="step-desc">
                Show off your expertise with relevant problem-solving tasks.
              </p>
              <div class="step-number">04</div>
            </div>
            <div class="step-card step-card5">
            <div className="iconouter">
              <div class="icon">
                <Image
                  src={FinalRound}
                  alt="Final Round"
                />
                </div>
              </div>
              <h3 class="step-title">Final Round</h3>
              <p class="step-desc">
                Meet our leadership team and discuss your future with iKnot Analytics.
              </p>
              <div class="step-number">05</div>
            </div>
          </div>
        </div>
      </section>


      {/* Apply Form Section */}
      <div className="common_careerssection" id="applyform" ref={applyFormRef}>
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Current Openings</h2>
            <p className="common_desc">Explore opportunities to be part of something extraordinary.</p>
          </div>

          <div className="job_opning_listinner">
            {/* BI Developer Opening */}
            <div className="job_opning_list">
              <h3 className="cr_hd">BI Developer</h3>
              <p className="cr_desc exp_yrs">
                <WorkHistoryIcon /> 4+ years
              </p>
              <p className="cr_desc loc_cr">
                <LocationOnIcon /> Remote/Hybrid
              </p>
              <Link href="/careers-details-bi-developers" className="vi_btn">
                VIEW DETAILS
              </Link>
            </div>

            {/* Data Engineer Opening */}
            <div className="job_opning_list">
              <h3 className="cr_hd">Data Engineer</h3>
              <p className="cr_desc exp_yrs">
                <WorkHistoryIcon /> 4+ years
              </p>
              <p className="cr_desc loc_cr">
                <LocationOnIcon /> Remote/Hybrid
              </p>
              <Link href="/careers-details-data-engineer" className="vi_btn">
                VIEW DETAILS
              </Link>
            </div>

            {/* Senior Data Engineer Opening */}
            <div className="job_opning_list">
              <h3 className="cr_hd">Senior Data Engineer</h3>
              <p className="cr_desc exp_yrs">
                <WorkHistoryIcon /> 7+ years
              </p>
              <p className="cr_desc loc_cr">
                <LocationOnIcon /> Remote/Hybrid
              </p>
              <Link href="/careers-details-senior-data-engineer" className="vi_btn">
                VIEW DETAILS
              </Link>
            </div>
          </div>
          <div className="job_opning_listbottom">
          <div className="common_titbox">
            <h2 className="common_hd">Can’t find the right role?</h2>
            <div className="key_takeways1">
              <p>No worries! Send us your resume and a cover letter to <Link href="mailto:careers@iknotanalytics.com"> careers@iknotanalytics.com,</Link> and we’ll reach out when we find a match.</p>
            </div>

           
          </div>
          </div>
        </div>
      </div>
      
    </>
  );
}
